import _ from "lodash";
import EventEmitter from "eventemitter3";

const MAX_ERRORS = 3;

class FileUpload extends EventEmitter {
  constructor(props, api) {
    super();

    this.api = api;
    this.file = props.file;
    this.id = props.id;
    this.name = this.file.name;

    this.meta = _.pick(props, ["width", "height", "folder_id"]);

    this.uploadInfo = null; //returned from the server contains URL to upload to.
    this.asset = null; //returned from the server

    this.error = false;
    this.s3Error = false;

    this.destroyed = false;
    this.progress = 0;

    this.status = 0;
  }

  start() {
    var fileData = {
      filename: this.name,
      size: this.file.size,
    };

    _.merge(fileData, this.meta);

    this.api
      .prepareUpload(fileData)
      .then(this._receiveUploadData.bind(this))
      .catch(this._prepareFailed.bind(this));
  }

  upload() {
    this.api
      .s3Upload(this.uploadInfo, this.file, this._uploadProgress.bind(this))
      .then(this._s3Complete.bind(this))
      .catch(this._s3Failed.bind(this));
  }

  _receiveUploadData(data) {
    this.status = 1;
    this.asset = data.asset;
    this.uploadInfo = data.upload;

    this.emit("asset", this.asset, this);
  }

  _prepareFailed(err) {
    this.status = 9;
    this.error = true;

    this.emit("error", err, this);
  }

  _uploadProgress(e) {
    this.progress = e.percent;

    this.emit("progress", this.progress, this);
  }

  _s3Complete(data) {
    this.status = 2;
    this.api
      .completeUpload(this.uploadInfo.upload_id, {})
      .then(this._finalizeComplete.bind(this))
      .catch(this._finalizeFailed.bind(this));
  }

  _s3Failed(err) {
    console.log("S3 Upload Failed", err);
    this.status = 9;
    this.s3Error = true;
    this.error = true;

    if (!_.isEmpty(err.response)) {
      var code = /<Code>(.+?)<\/Code>/g.exec(err.response.text);
      if (code.length > 0) {
        var data = {
          error: 1,
          message: code[1],
        };

        this.api
          .completeUpload(this.uploadInfo.upload_id, data)
          .then(this._finalizeComplete.bind(this))
          .catch(this._finalizeFailed.bind(this));
      }
    }
  }

  _finalizeComplete(data) {
    this.status = 3;
    this.completeData = data;
    this.emit("complete", this);
  }

  _finalizeFailed(err) {
    this.status = 9;
    this.error = true;
    this.emit("complete", this);
  }

  destroy() {
    this.api = null;
    this.file = null;
    this.destroyed = true;
  }
}

export default FileUpload;
